import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthenticateEenMutationVariables = Types.Exact<{
  input: Types.EenAuthenticateInput;
}>;


export type AuthenticateEenMutation = { __typename?: 'mutation_root', authenticate_een?: { __typename?: 'EenAuthenticateOutput', success: boolean } | null };


export const AuthenticateEenDocument = gql`
    mutation authenticateEen($input: EenAuthenticateInput!) {
  authenticate_een(input: $input) {
    success
  }
}
    `;
export type AuthenticateEenMutationFn = Apollo.MutationFunction<AuthenticateEenMutation, AuthenticateEenMutationVariables>;

/**
 * __useAuthenticateEenMutation__
 *
 * To run a mutation, you first call `useAuthenticateEenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateEenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateEenMutation, { data, loading, error }] = useAuthenticateEenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateEenMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateEenMutation, AuthenticateEenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateEenMutation, AuthenticateEenMutationVariables>(AuthenticateEenDocument, options);
      }
export type AuthenticateEenMutationHookResult = ReturnType<typeof useAuthenticateEenMutation>;
export type AuthenticateEenMutationResult = Apollo.MutationResult<AuthenticateEenMutation>;
export type AuthenticateEenMutationOptions = Apollo.BaseMutationOptions<AuthenticateEenMutation, AuthenticateEenMutationVariables>;